/** F4 - duas colunas: marca a esquerda, formulario a direita. Unica rota publica. */
import { useState } from 'react';
import { useIdioma, IDIOMAS } from '../i18n/index.tsx';
import { useSessao } from '../sessao.tsx';
import './login.css';

const MENSAGEM: Record<string, 'erro.credenciais' | 'erro.muitas' | 'erro.rede'> = {
  credenciais_invalidas: 'erro.credenciais',
  entrada_invalida: 'erro.credenciais',
  muitas_tentativas: 'erro.muitas',
  rede: 'erro.rede',
};

export function Login() {
  const { t, idioma, trocar } = useIdioma();
  const { entrar } = useSessao();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const enviar = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    const r = await entrar(email, senha);
    setEnviando(false);
    if (!r.ok) setErro(t(MENSAGEM[r.codigo] ?? 'erro.credenciais'));
  };

  return (
    <div className="login">
      <aside className="login__marca">
        <div className="login__marca-topo">
          <img className="login__logotipo" src="/marca/logo-tme-horizontal.png"
            alt="Terapia Manual Evolutiva TME" />
        </div>
        <p className="login__frase">{t('login.marca.frase')}</p>
        <span className="kicker login__dominio">crm.tmebrasil.com.br</span>
      </aside>

      <main className="login__painel">
        <form className="login__form" onSubmit={enviar} noValidate>
          <span className="kicker login__kicker">{t('app.nome')}</span>
          <h1 className="login__titulo">{t('login.titulo')}</h1>
          <p className="login__subtitulo">{t('login.subtitulo')}</p>

          <label className="campo">
            <span className="campo__rotulo">{t('login.email')}</span>
            <input
              className="campo__entrada" type="email" name="email" autoComplete="email"
              required autoFocus value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <label className="campo">
            <span className="campo__rotulo">{t('login.senha')}</span>
            <input
              className="campo__entrada" type="password" name="senha"
              autoComplete="current-password" required value={senha}
              onChange={(e) => setSenha(e.target.value)}
            />
          </label>

          {erro !== null && <p className="login__erro" role="alert">{erro}</p>}

          <button className="botao botao--primario" type="submit" disabled={enviando}>
            {enviando ? t('login.entrando') : t('login.entrar')}
          </button>

          <a className="login__esqueci" href="/recuperar">{t('login.esqueci')}</a>

          <div className="login__idiomas">
            {IDIOMAS.map((i) => (
              <button
                key={i} type="button"
                className={`login__idioma${i === idioma ? ' login__idioma--ativo' : ''}`}
                onClick={() => trocar(i)}
              >{i.toUpperCase()}</button>
            ))}
          </div>
        </form>
      </main>
    </div>
  );
}
